<script setup lang="ts">
import UpdateBanner from './shared/UpdateBanner.vue'
</script>

<template>
  <UpdateBanner />
  <RouterView />
</template>
